<div class="container">
    <div tid="note_list_sentiment" class="right-top-corner">
        <smart-icon name="sentiment"
            [ngClass]="{'positive': threadEntry.threadEntrySentiment === 1, 'negative': threadEntry.threadEntrySentiment === -1}">
        </smart-icon>
    </div>
    <div class="container-item">
        <div class="item-row" kendoTooltip position="bottom">
            <div tid="note_list_note_type" class="note-type-label" [title]="threadEntry.threadEntryType.name">
                <span>{{threadEntry.threadEntryType.name}}</span>
            </div>
            <div class="date-source-area">
                <div tid="note_list_source" class="source-label" [title]="threadEntry.threadEntrySource.name">
                    <span>{{threadEntry.threadEntrySource.name}}</span>
                </div>
                <div tid="note_list_date" class="date-label">
                    <span *ngIf="sortInfo&&sortInfo.sortBy === 'displayDate'">&nbsp;|&nbsp;{{threadEntry.displayDate |
                        todayOrPastSimpleDateWithShortMonth}}</span>
                    <span *ngIf="sortInfo&&sortInfo.sortBy === 'submittedDate'">&nbsp;|&nbsp;{{threadEntry.submittedDate
                        | todayOrPastSimpleDateWithShortMonth}}</span>
                    <span
                        *ngIf="sortInfo&&sortInfo.sortBy === 'lastModifiedDate'">&nbsp;|&nbsp;{{threadEntry.lastEditedDate
                        | todayOrPastSimpleDateWithShortMonth}}</span>
                </div>
            </div>
        </div>
        <div class="item-row">
            <div tid="note_list_subject" class="subject-label" title="{{threadEntry.threadEntryCalculatedSubject}}">
                <span>{{threadEntry.threadEntryCalculatedSubject}}</span>
            </div>
        </div>
        <div class="item-row" kendoTooltip position="bottom">
            <div class="entities-area" tid="note_list_entity" [title]="entitiesInString" tamDynamicTooltip>
                <div class="entity-tag" *ngFor="let item of threadEntry.entities;trackBy:trackByFn">
                    <span>{{item.shortName}}</span>
                </div>
            </div>
            <div tid="note_list_priority" class="priority-area" *ngIf="threadEntry.threadEntryPriority > 0">
                <priority-star [value]="threadEntry.threadEntryPriority"></priority-star>
            </div>
            <div tid="note_list_sidenote_number" class="sidenote-area"
                *ngIf="threadEntry.notes.length > 1 && threadEntry.threadEntryParseByThread">
                <smart-icon name="side-note"></smart-icon>
                <div class="number">
                    <span>{{(threadEntry.notes.length - 1)}}</span>
                </div>
            </div>
            <div tid="note_list_sidenote_number" class="sidenote-area"
                *ngIf="threadEntry.threadEntryTotalNotesInThread > 1 && !threadEntry.threadEntryParseByThread">
                <div class="number">
                    <span>{{threadEntry.threadEntryThreadPosition +
                        1}}/{{threadEntry.threadEntryTotalNotesInThread}}</span>
                </div>
            </div>
            <div tid="note_list_attachment_number" class="attachment-area"
                *ngIf="threadEntry.threadEntryAttachments.size > 0">
                <smart-icon class="icon" name="attachment" *ngIf="threadEntry.threadEntryAttachments.size > 1">
                </smart-icon>
                <img [src]="imgSrc" class="img" *ngIf="threadEntry.threadEntryAttachments.size === 1">
                <div class="number" *ngIf="threadEntry.threadEntryAttachments.size > 1">
                    {{threadEntry.threadEntryAttachments.size}}</div>
            </div>
        </div>
    </div>
</div>